import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { useLinkConnected } from '../../../store/link/hooks'
import { useWeb3Address, useWeb3Connected } from '../../../store/web3/hooks'
import { useWeb3React } from '@web3-react/core'
import { updateModal } from '../../../store/app/actions/modalActions'
import Iconfont from '../../../components/Iconfont'
import { ConnectButton } from '../ConnectButton'
import { Stack, styled } from '@mui/material'
import { encryptionAddress } from 'utils/address'
import { ReactComponent as SvgELipse } from 'assets/account/ellipse.svg'
import { FlexCenter } from 'styles'
import { ReactComponent as ArrowSvg } from './arrow.svg'
import { transientOptions } from 'styles/TransientOptions'

const CurrentAddressWrap = styled(Stack)`
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: 400;
  color: ${({ theme }) => theme.color.text60};
  position: relative;
`

const StyledSvgELipse = styled(SvgELipse)`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`

const WarningIcon = styled(Iconfont)`
  color: ${({ theme }) => theme.palette.warning.main};
`

export const CurrentAddress = memo(() => {
  const dispatch = useDispatch()
  const isLinkConnected = useLinkConnected()
  const address = useWeb3Address()
  const web3Connected = useWeb3Connected()
  const { ENSName } = useWeb3React()

  if (!web3Connected) {
    return <ConnectButton />
  }

  const handleClick = () => {
    if (!isLinkConnected) {
      dispatch(updateModal({ modal: 'verify', open: true }))
    }
  }

  return (
    <CurrentAddressWrap onClick={handleClick}>
      {!isLinkConnected && <WarningIcon name="icon-Warning1" size={20} />}
      <FlexCenter>
        {isLinkConnected && <StyledSvgELipse />}
        {ENSName ?? encryptionAddress(address)}
      </FlexCenter>
    </CurrentAddressWrap>
  )
})
